<template>
  <div class="flex flex-wrap text-center sm:text-left">
    <div class="w-full md:w-10/12 md:ml-8.333333% xl:w-11/12 xl:ml-8.333333% px-15">
      <h2 class="text-h4 mb-16 border-b-2 border-grey-divider-subdued pb-8">{{ title }}</h2>
      <p class="text-body text-grey-text-subdued mb-0">{{ message }}</p>

      <Button
        v-if="actionText && actionTo"
        class="w-full md:w-auto mt-32"
        :to="actionTo"
        variant="primary"
        size="medium"
        @click="onAction"
      >
        {{ actionText }}
      </Button>

      <Button
        v-else-if="actionText && actionUrl"
        class="w-full md:w-auto mt-32"
        :href="actionUrl"
        variant="primary"
        size="medium"
        @click="onAction"
      >
        {{ actionText }}
      </Button>

      <Button v-else-if="actionText" class="w-full md:w-auto mt-32" variant="primary" size="medium" @click="onAction">
        {{ actionText }}
      </Button>
    </div>
  </div>
</template>

<script lang="ts">
import { PropType } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
import Button from '../button/Button.vue';

export default {
  name: 'EmptyStateCard',
  components: {
    Button,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    actionText: {
      type: String,
      default: '',
    },
    actionUrl: {
      type: String,
      default: '',
    },
    actionTo: {
      type: [String, Object] as PropType<RouteLocationRaw>,
      default: null,
    },
    variant: {
      type: String,
      default: 'default',
      validator(value: string) {
        return ['default', 'sitter', 'parent'].includes(value);
      },
    },
  },
  methods: {
    onAction() {
      this.$emit('action');
    },
  },
};
</script>
